const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  body: {
    "& tr": {
      borderBottom: "solid 1px rgba(118, 143, 221, 0.5)",
    },
  },
  list: {
    backgroundColor: theme.palette.lightGrey.main,
    margin: theme.spacing(5),
    borderRadius: 5,
    listStyle: "none",
  },
  addCodeButton: {
    backgroundColor: theme.palette.orange.main,
    borderRadius: 8,
    color: "#ffffff",
    marginBottom: 24,
    marginTop: 8,
    fontWeight: 900,
    fontSize: 14,
    textTransform: "none",
    padding: "8px 16px",
    boxShadow: "0px 4px 12px rgba(244, 138, 33, 0.2)",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: theme.palette.orange.dark,
      transform: "translateY(-2px)",
      boxShadow: "0px 6px 16px rgba(244, 138, 33, 0.3)",
    },
  },
  tourDeactivated: {
    textAlign: "center",
    borderRadius: 8,
    color: "#C62828",
    marginBottom: 8,
    marginTop: 8,
    fontWeight: 900,
    fontSize: 14,
    textTransform: "none",
    backgroundColor: "rgba(255, 77, 77, 0.1)",
    padding: "8px",
  },
  searchInput: {
    marginBottom: 24,
    width: "40%",
    "& .MuiOutlinedInput-root": {
      backgroundColor: "white",
      borderRadius: 8,
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  table: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 12,
    overflowX: "auto",
    overflowY: "hidden",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
  },
  codesTable: {
    minWidth: 560,
  },
  tableCellHeader: {
    color: "#ffffff",
    fontWeight: 600,
    fontSize: 13,
    borderBottom: "solid 1px rgba(118, 143, 221, 0.5)",
    backgroundColor: theme.palette.darkGrey.main,
    padding: "12px",
    "&:first-child": {
      paddingLeft: "16px",
    },
    "&:last-child": {
      paddingRight: "16px",
    },
  },
  tableCell: {
    color: "#ffffff",
    borderBottom: "solid 1px rgba(118, 143, 221, 0.5)",
    padding: "12px",
    "&:first-child": {
      paddingLeft: "16px",
    },
    "&:last-child": {
      paddingRight: "16px",
    },
  },
  alreadySentMailButton: {
    color: "#ffffff",
    backgroundColor: "rgba(34, 170, 0, 0.4)",
    borderRadius: 8,
    textTransform: "none",
    padding: "8px 12px",
    fontSize: 13,
    boxShadow: "0px 4px 12px rgba(34, 170, 0, 0.1)",
    transition: "background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      backgroundColor: theme.palette.green.main,
      transform: "translateY(-2px)",
      boxShadow: "0px 6px 16px rgba(34, 170, 0, 0.3)",
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(255, 255, 255, 0.12)",
      color: "rgba(255, 255, 255, 0.45)",
      boxShadow: "none",
    },
    "&.Mui-focusVisible": {
      outline: "2px solid #FFFFFF",
      outlineOffset: 2,
    },
  },
  sendMailButton: {
    color: "#ffffff",
    backgroundColor: "#1B8A00",
    borderRadius: 8,
    textTransform: "none",
    padding: "8px 12px",
    fontSize: 13,
    boxShadow: "0px 4px 12px rgba(34, 170, 0, 0.2)",
    transition: "background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      backgroundColor: "#167300",
      transform: "translateY(-2px)",
      boxShadow: "0px 6px 16px rgba(34, 170, 0, 0.3)",
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(255, 255, 255, 0.12)",
      color: "rgba(255, 255, 255, 0.45)",
      boxShadow: "none",
    },
    "&.Mui-focusVisible": {
      outline: "2px solid #FFFFFF",
      outlineOffset: 2,
    },
  },
  disabledSendMailButton: {
    color: "#ffffff",
    backgroundColor: "#F1DBC5",
    borderRadius: 8,
    textTransform: "none",
    padding: "6px 12px",
    fontSize: 13,
  },
  buttonDisabled: {
    backgroundColor: "#8e999d",
    cursor: "default",
    "&:hover": {
      backgroundColor: "#8e999d",
    },
  },
  switchVisibility: {
    display: "inline",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  statusBadge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "3px 8px",
    borderRadius: "12px",
    fontSize: 11,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  statusActive: {
    backgroundColor: "rgba(74, 222, 128, 0.12)",
    color: "#4ADE80",
  },
  statusExpired: {
    backgroundColor: "rgba(255, 128, 128, 0.12)",
    color: "#FF8080",
  },
  statusPending: {
    backgroundColor: "rgba(244, 138, 33, 0.1)",
    color: theme.palette.orange.main,
  },
  detailsButton: {
    color: "#ffffff",
    padding: "6px",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
    "&.Mui-focusVisible": {
      outline: "2px solid #FFFFFF",
    },
  },
  archiveButton: {
    transition: "filter 0.2s ease",
    "&:hover": {
      filter: "brightness(0.9)",
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  pagination: {
    color: "#ffffff",
    "& .MuiTablePagination-select": {
      color: "#ffffff",
    },
    "& .MuiTablePagination-selectIcon": {
      color: "#ffffff",
    },
    "& .MuiIconButton-root": {
      color: "#ffffff",
    },
    "& .MuiIconButton-root.Mui-disabled": {
      color: "rgba(255, 255, 255, 0.3)",
    },
  },
});

export default styles;
